import { useState, useId } from "react";

export const AccordionList = ({ items, testPrefix }) => {
  const [open, setOpen] = useState(0);
  const baseId = useId();
  return (
    <div className="border-t border-[var(--line)]">
      {items.map((item, i) => {
        const isOpen = open === i;
        const headingId = `${baseId}-h-${i}`;
        const panelId = `${baseId}-p-${i}`;
        return (
          <div key={i} className="border-b border-[var(--line)]">
            <h3 id={headingId} className="m-0">
              <button
                data-testid={`${testPrefix}-trigger-${i}`}
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="w-full flex items-baseline gap-5 py-6 md:py-7 text-left group"
              >
                <span className="font-mono text-xs md:text-sm text-[var(--muted)] shrink-0 pt-1">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="flex-1 text-base md:text-xl font-medium tracking-wide text-white group-hover:text-[var(--accent)] transition-colors duration-300">
                  {item.title}
                </span>
                <span
                  aria-hidden="true"
                  className={`font-mono text-lg text-[var(--accent)] transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`}
                >
                  +
                </span>
              </button>
            </h3>
            <div
              id={panelId}
              role="region"
              aria-labelledby={headingId}
              className={`grid transition-[grid-template-rows] duration-400 ease-out ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
            >
              <div className="overflow-hidden">
                <p className="pb-7 pl-9 md:pl-12 pr-4 text-sm md:text-base leading-relaxed text-[var(--muted)] max-w-2xl">
                  {item.body}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
